import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { API_BASE, photoUrl } from "../lib/api";
import { Button } from "../components/ui/button";
import { Printer, ChevronLeft, AlertTriangle } from "lucide-react";

export default function LostPoster() {
  const { petId } = useParams();
  const [pet, setPet] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get("/pets")
      .then((r) => {
        const p = r.data.find((x) => x.pet_id === petId);
        if (p) setPet(p); else setNotFound(true);
      })
      .catch(() => setNotFound(true));
  }, [petId]);

  if (notFound) return <div className="max-w-2xl mx-auto px-6 py-20 text-center text-muted-foreground">Pet não encontrado.</div>;
  if (!pet) return <div className="max-w-2xl mx-auto px-6 py-20 text-center text-muted-foreground">Carregando...</div>;

  return (
    <div className="max-w-2xl mx-auto px-6 py-10" data-testid="lost-poster-page">
      <style>{`@media print { header, footer, .no-print { display: none !important; } body { background: white !important; } }`}</style>
      <div className="flex items-center justify-between mb-6 no-print">
        <Link to="/app" className="inline-flex items-center text-sm text-muted-foreground hover:text-brand-coral" data-testid="back-to-app">
          <ChevronLeft className="w-4 h-4" /> Voltar
        </Link>
        <Button onClick={() => window.print()} className="bg-brand-coral hover:bg-brand-coralDark text-white rounded-full" data-testid="print-poster-btn">
          <Printer className="w-4 h-4 mr-2" /> Imprimir cartaz
        </Button>
      </div>

      <div className="bg-white rounded-2xl border-4 border-red-600 overflow-hidden shadow-lg" data-testid="poster-content">
        <div className="bg-red-600 text-white text-center py-5">
          <AlertTriangle className="w-8 h-8 mx-auto mb-1" />
          <h1 className="font-heading font-extrabold text-4xl tracking-wide">PROCURA-SE</h1>
        </div>
        {pet.photo && <img src={photoUrl(pet.photo)} alt={pet.name} className="w-full h-80 object-cover" />}
        <div className="p-8 text-center">
          <h2 className="font-heading font-extrabold text-4xl text-brand-graphite">{pet.name}</h2>
          <p className="text-lg text-muted-foreground mt-1">{pet.species}{pet.breed ? ` • ${pet.breed}` : ""}</p>
          {pet.lost?.location && <p className="mt-3 text-brand-graphite"><strong>Visto por último:</strong> {pet.lost.location}</p>}
          {pet.lost?.message && <p className="mt-2 text-muted-foreground italic">"{pet.lost.message}"</p>}
          {pet.lost?.since && <p className="text-sm text-muted-foreground mt-1">Desaparecido desde {pet.lost.since.slice(0, 10).split("-").reverse().join("/")}</p>}

          {pet.tag_code ? (
            <div className="mt-8 flex flex-col items-center">
              <img src={`${API_BASE}/tags/${pet.tag_code}/qr.png`} alt="QR Code" className="w-52 h-52" data-testid="poster-qr" />
              <p className="font-heading font-bold text-lg text-brand-graphite mt-3">Encontrou? Escaneie o QR code</p>
              <p className="text-sm text-muted-foreground">Você avisará meu tutor na hora, direto pelo celular.</p>
            </div>
          ) : (
            <p className="mt-8 text-sm text-muted-foreground no-print">Este pet ainda não tem tag vinculada — adquira uma na <Link to="/loja" className="text-brand-coral font-semibold">Loja de Tags</Link>.</p>
          )}
        </div>
        <div className="bg-brand-cream text-center py-3 text-xs text-muted-foreground">
          PetMachine Hub — a comunidade que traz pets de volta • petmachinehub.com.br
        </div>
      </div>
    </div>
  );
}
